export enum ReviewCategory {
  OverallHealth = 'overall-health',
  PuppyCare = 'puppy-care',
  SeniorCare = 'senior-care',
  WeightIssues = 'weight-issues',
  Digestion = 'digestion',
  PickyEating = 'picky-eating',
  SkinAndCoat = 'skin-and-coat',
}

export const categories: Record<ReviewCategory, string> = {
  [ReviewCategory.OverallHealth]: 'Overall Health',
  [ReviewCategory.PuppyCare]: 'Puppy Care',
  [ReviewCategory.SeniorCare]: 'Senior Care',
  [ReviewCategory.WeightIssues]: 'Weight Issues',
  [ReviewCategory.Digestion]: 'Digestion',
  [ReviewCategory.PickyEating]: 'Picky Eating',
  [ReviewCategory.SkinAndCoat]: 'Skin & Coat',
};
